"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sign Internal OpenAPI
 * Sign Internal OpenAPI spec
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsToJSON = exports.SettingsFromJSONTyped = exports.SettingsFromJSON = exports.instanceOfSettings = exports.attributeTypeMapSettings = void 0;
exports.attributeTypeMapSettings = [
    {
        name: "addCoverPage",
        type: "boolean",
    },
    {
        name: "recipientOrder",
        type: "boolean",
    },
    {
        name: "recipientReassignment",
        type: "boolean",
    },
    {
        name: "requireSignerInfo",
        type: "boolean",
    },
    {
        name: "sendHighResFax",
        type: "boolean",
    },
    {
        name: "qes",
        type: "boolean",
    },
    {
        name: "nom151",
        type: "boolean",
    },
    {
        name: "hasForm",
        type: "boolean",
    },
];
/**
 * Check if a given object implements the Settings interface.
 */
function instanceOfSettings(value) {
    return true;
}
exports.instanceOfSettings = instanceOfSettings;
function SettingsFromJSON(json) {
    return SettingsFromJSONTyped(json, false);
}
exports.SettingsFromJSON = SettingsFromJSON;
function SettingsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        addCoverPage: json["add_cover_page"] == null ? undefined : json["add_cover_page"],
        recipientOrder: json["recipient_order"] == null ? undefined : json["recipient_order"],
        recipientReassignment: json["recipient_reassignment"] == null
            ? undefined
            : json["recipient_reassignment"],
        requireSignerInfo: json["require_signer_info"] == null
            ? undefined
            : json["require_signer_info"],
        sendHighResFax: json["send_high_res_fax"] == null ? undefined : json["send_high_res_fax"],
        qes: json["qes"] == null ? undefined : json["qes"],
        nom151: json["nom151"] == null ? undefined : json["nom151"],
        hasForm: json["hasForm"] == null ? undefined : json["hasForm"],
    };
}
exports.SettingsFromJSONTyped = SettingsFromJSONTyped;
function SettingsToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        add_cover_page: value["addCoverPage"],
        recipient_order: value["recipientOrder"],
        recipient_reassignment: value["recipientReassignment"],
        require_signer_info: value["requireSignerInfo"],
        send_high_res_fax: value["sendHighResFax"],
        qes: value["qes"],
        nom151: value["nom151"],
        hasForm: value["hasForm"],
    };
}
exports.SettingsToJSON = SettingsToJSON;
